export const COURIER_TYPES = [
  {
    title: "Instant",
    value: "instant",
  },
  {
    title: "Express",
    value: "express",
  },
];
